import React, {Component, Suspense} from 'react';
import {Route, Switch, withRouter, Redirect} from 'react-router-dom';
import { connect } from 'react-redux';

import * as billboardActions from '../actions/index';
import * as userActions from '../../global/user/actions/index';

const SplitView = React.lazy(() => import('../../global/split_view/split_view'));
const SectionHeader = React.lazy(() => import('../../global/table_elements/section_header/section_header'));
const TableRow = React.lazy(() => import('../../global/table_elements/table_row/table_row'));

const BillboardIndex = React.lazy(() => import('../billboard_index/billboard_index'));
import LoadingIndicator from '../../global/loading_indicator/loading_indicator';
import logger from '../../global/logger';
const BillboardPlaylistEditView = React.lazy(() => import('../billboard_playlist_edit_view/billboard_playlist_edit_view'));
const BillboardDeviceEditView = React.lazy(() => import('../billboard_device_edit_view/billboard_device_edit_view'));
const BillboardMediaLibraryView = React.lazy(() => import('../billboard_media_library_view/billboard_media_library_view'));
const BillboardPairNewDeviceView = React.lazy(() => import('../billboard_pair_new_device_view/billboard_pair_new_device_view'));
const BillboardSeriesArtView = React.lazy(() => import('../billboard_series_art_view/billboard_series_art_view'));

class BillboardLayout extends Component {

    constructor(props) {
        super(props);
        this.splitView = React.createRef();
        this.authTokenCallback = this.authTokenCallback.bind(this);
    }

    componentDidMount() {
        this.props.onUpdateAuthToken(this.authTokenCallback);
    }

    authTokenCallback() {
        this.props.onFetchPlaylists(() => {
            let playlists = this.sortedPlaylists();
            if (playlists.length > 0) {
                this.selectPlaylist(playlists[0]);
            }
        });
        this.props.onFetchDevices(this.deviceLoadCallback);
        this.props.onFetchMedia(this.mediaLoadCallback);
    }

    selectPlaylist(playlist) {
        this.goToPage("/billboard/playlists/" + playlist.id);
    }

    mediaLoadCallback() {
        logger.log("mediaLoadCallback");
    }

    sortedPlaylists() {
        let playlists = []

        if (this.props.playlists) {
            playlists = this.props.playlists;
            playlists.sort(function(a, b) {
                let nameA = a.title.toUpperCase();
                let nameB = b.title.toUpperCase();
                if (nameA < nameB) {
                    return -1;
                  }
                  if (nameA > nameB) {
                    return 1;
                  }
                
                  // names must be equal
                  return 0;
            });
        }

        return playlists;
    }

    deviceLoadCallback() {
        // let devices = this.sortedDevices();
        logger.log("deviceLoadCallback");
    }

    sortedDevices() {
        let devices = []

        if (this.props.devices) {
            devices = this.props.devices;
        }

        return devices;
    }

    pairNewDevice = () => {
        this.props.onPairNewDevice();
        this.props.history.push("/billboard/devices/new");
        this.splitView.current.collapsePopover();
    }

    createPlaylistCallback = () => {
        logger.log("createPlaylistCallback");
    }

    nextPlaylistTitle = () => {
        const base = 'Untitled Playlist';
        const playlists = this.sortedPlaylists();
        const existing = playlists
            .map(p => p.title)
            .filter(t => t === base || /^Untitled Playlist \d+$/.test(t));
        if (existing.length === 0) return base;
        const numbers = existing.map(t => {
            const match = t.match(/^Untitled Playlist (\d+)$/);
            return match ? parseInt(match[1], 10) : 1;
        });
        return `${base} ${Math.max(...numbers) + 1}`;
    }

    createPlaylist = () => {
        this.props.onCreatePlaylist(this.createPlaylistCallback, this.nextPlaylistTitle());
        this.splitView.current.collapsePopover();
    }

    goToPage = (pageLink) => {
        this.props.history.push(pageLink);
        this.splitView.current.collapsePopover();
    }

    rightSideComponent() {
        return (
            <Switch>
                <Route path="/billboard" exact component={BillboardIndex} />
                <Route path="/billboard/playlists" exact component={BillboardPlaylistEditView} />
                <Route path="/billboard/playlists/:id" component={BillboardPlaylistEditView} />
                <Route path="/billboard/playlists/new" exact component={BillboardPlaylistEditView} />
                <Route path="/billboard/media" exact component={BillboardMediaLibraryView} />
                <Route path="/billboard/series_art" exact component={BillboardSeriesArtView} />
                <Route path="/billboard/devices" exact component={BillboardDeviceEditView} />
                <Route path="/billboard/devices/new" exact component={BillboardPairNewDeviceView} />
                <Route path="/billboard/devices/:id" component={BillboardDeviceEditView} />
            </Switch>
        )
    }

    render () {

        let playlists = this.sortedPlaylists();
        let devices = this.sortedDevices();

        const hasPlaylists = playlists.length > 0;
        const hasDevices = devices.length > 0;

        let playlists_section = (
            <div>
                <Suspense fallback={<LoadingIndicator />}>
                    <SectionHeader text="Playlists" accessory={hasPlaylists ? <p><a className="text-sm text-blue-500 cursor-pointer hover:bg-blue-500 hover:text-white rounded-sm p-1 px-2" onClick={() => this.createPlaylist()}>Add New Playlist</a></p> : null} />
                    {!hasPlaylists && !this.props.loading_playlists && (
                        <div className="px-4 py-3">
                            <div className="bg-gray-100 flex flex-col items-center justify-center rounded-3xl" style={{ aspectRatio: '16/9' }}>
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#a0aec0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                    <polygon points="23 7 16 12 23 17 23 7" />
                                    <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
                                </svg>
                                <a
                                    className="mt-3 text-sm cursor-pointer bg-blue-500 rounded-sm p-1 px-3" style={{ color: 'white' }}
                                    onClick={() => this.createPlaylist()}
                                >
                                    Add New Playlist
                                </a>
                            </div>
                        </div>
                    )}
                    {playlists.map((playlist) => (
                        <Route key={playlist.id} exact path={"/billboard/playlists/" + playlist.id} children={({match}) => (
                            <TableRow key={"playlist_" + playlist.id} selected={match} clickEvent={() => this.goToPage("/billboard/playlists/" + playlist.id)} text={playlist.title} link={"/billboard/playlists/" + playlist.id} icon={playlist.photo_url} />
                        )} />
                    ))}
                    <SectionHeader text="Devices" accessory={hasDevices ? <p><a className="text-sm text-blue-500 cursor-pointer hover:bg-blue-500 hover:text-white rounded-sm p-1 px-2" onClick={() => this.pairNewDevice()}>Pair New Device</a></p> : null} />
                    {!hasDevices && !this.props.loading_playlists && (
                        <div className="px-4 py-3">
                            <div className="bg-gray-100 flex flex-col items-center justify-center rounded-3xl" style={{ aspectRatio: '16/9' }}>
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#a0aec0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
                                    <line x1="8" y1="21" x2="16" y2="21" />
                                    <line x1="12" y1="17" x2="12" y2="21" />
                                </svg>
                                <a
                                    className="mt-3 text-sm cursor-pointer bg-blue-500 rounded-sm p-1 px-3" style={{ color: 'white' }}
                                    onClick={() => this.pairNewDevice()}
                                >
                                    Pair New Device
                                </a>
                            </div>
                        </div>
                    )}
                    {devices.map((device) => (
                        <Route key={device.id} exact path={"/billboard/devices/" + device.id} children={({match}) => (
                            <TableRow key={"device_" + device.id} selected={match} clickEvent={() => this.goToPage("/billboard/devices/" + device.id)} text={device.title} link={"/billboard/devices/" + device.id} icon={device.photo_url} />
                        )} />
                    ))}
                    <SectionHeader text="Media Libraries" />
                    <Route exact path="/billboard/media" children={({match}) => (
                        <TableRow key="media_library_row" link="/billboard/media" text="Media Library" selected={match} clickEvent={() => this.goToPage('/billboard/media')} />
                    )} />
                    {/* #482 — below "Media Library" per the issue's nav placement. */}
                    <Route exact path="/billboard/series_art" children={({match}) => (
                        <TableRow key="series_art_row" link="/billboard/series_art" text="Series Art" selected={match} clickEvent={() => this.goToPage('/billboard/series_art')} />
                    )} />

                </Suspense>
            </div>
        );
        if (this.props.loading_playlists) {
            playlists_section = (
                <div>

                </div>
            );
        }

        let left = (
            <div>
                {playlists_section}
            </div>
        );

        let right = (
            <Suspense fallback={<LoadingIndicator />}>
                {this.rightSideComponent()}
            </Suspense>
        );

        return (
            <Suspense fallback={<LoadingIndicator />}>
                <SplitView ref={this.splitView} left={left} right={right} />
            </Suspense>
        );
    }
}

const mapStateToProps = state => {
    return {
        loading_playlists: state.billboard.loading_playlists,
        playlists: state.billboard.playlists,
        selected_playlist: state.billboard.selected_playlist,
        devices: state.billboard.devices,
        selected_device: state.billboard.selected_device,
        media_library_is_selected: state.billboard.media_library_is_selected,
        pairing_new_device: state.billboard.pairing_new_device,
        media: state.billboard.media,
        selected_media: state.billboard.selected_media,
        loading_media: state.billboard.loading_media,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onFetchPlaylists: (callback) => dispatch(billboardActions.fetchPlaylists(callback)),
        onSelectPlaylist: (playlist) => dispatch(billboardActions.selectPlaylist(playlist)),
        onCreatePlaylist: (callback, title) => dispatch(billboardActions.createPlaylist(callback, title)),
        onFetchDevices: (callback) => dispatch(billboardActions.fetchDevices(callback)),
        onSelectDevice: (device) => dispatch(billboardActions.selectDevice(device)),
        onPairNewDevice: () => dispatch(billboardActions.pairNewDevice()),
        onSelectMediaLibrary: (media_library) => dispatch(billboardActions.selectMediaLibrary(media_library)),
        onUpdateAuthToken: (callback) => dispatch(userActions.updateAuthToken(callback)),
        onFetchMedia: (callback) => dispatch(billboardActions.fetchMedia(callback)),
        onSelectMedia: (media) => dispatch(billboardActions.selectMedia(media)),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BillboardLayout));